import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";

import {
  AsignarResponsableIsoBase,
  DatosAsignacionIso,
  VistaAsignacionIso,
} from "../../shared/incidencias-iso/asignar-responsable-iso-base";
import { RespuestaIso, idUsuarioEmpleadoIso, puestoEmpleadoIso } from "../../shared/incidencias-iso/incidencias-iso.comun";
import { Empleado } from "../../shared/model/empleado/empleado.model";
import { IncidenciaSeguridad } from "../../shared/model/iso42001/incidencia-seguridad.model";
import { IncidenciasSeguridadService } from "../incidencias-seguridad.service";

export type AsignarResponsableSeguridadData = DatosAsignacionIso<IncidenciaSeguridad>;

/** Pinta la plantilla de la asignación de incidencias IA con los textos y clases de seguridad. */
@Component({
  selector: "app-asignar-responsable-seguridad",
  standalone: true,
  templateUrl: "../../incidencias-ia/asignar-responsable-ia/asignar-responsable-ia.component.html",
  styleUrls: ["./asignar-responsable-seguridad.component.css"],
  imports: [CommonModule, FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule],
})
export class AsignarResponsableSeguridadComponent extends AsignarResponsableIsoBase<IncidenciaSeguridad> {
  readonly vista: VistaAsignacionIso = {
    claseModal: "incidencia-seguridad-ticket-modal",
    titulo: "Asignar responsable de resolucion",
    etiquetaResponsable: "Responsable de resolucion",
    clasePanel: "incidencia-seguridad-select-panel",
    etiquetaMotivo: "Motivo de la asignacion o reasignacion",
    placeholderMotivo: "Describe por que se asigna o cambia el responsable",
    sinResponsables: "No hay usuarios activos disponibles para asignar.",
  };

  protected readonly incidenciasService = inject(IncidenciasSeguridadService);

  get resumenIncidencia(): string {
    return this.data?.incidencia?.tipoIncidencia || "Sin tipo";
  }

  puestoResponsable(empleado: Empleado): string {
    return puestoEmpleadoIso(empleado);
  }

  protected listaResponsables(res: RespuestaIso<IncidenciaSeguridad>): Empleado[] {
    return res.responsables || [];
  }

  protected crearAsignacion(responsable: Empleado): IncidenciaSeguridad {
    return {
      idIncidenciaIa: this.data.incidencia.idIncidenciaIa,
      idEmpleadoResponsableResolucion: responsable.idEmpleado,
      idUsuarioResponsableResolucion: idUsuarioEmpleadoIso(responsable),
      responsableResolucion: this.nombreResponsable(responsable),
      responsableResolucionCargo: this.puestoResponsable(responsable),
      responsableResolucionPerfil: this.perfilResponsable(responsable),
    };
  }
}
